import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { useSpecialRights } from "../../../context/SpecialRightsContext";
import { usePreloadImageManifest } from "../../../hooks/usePreloadImageManifest";
import FullPageSpinner from "../../loading/FullpageSpinner/FullpageSpinner";
import { Toastify } from "../../widgets/Toastify/Toastify";
import AppContainer from "../AppContainer/AppContainer";
import Footer from "../Footer/Footer";
import Topbar from "../Topbar/Topbar";
import IrebookWelcomePopup from "../../widgets/WelcomePopup/WelcomePopup";

const AppContent = () => {
  const { isLoading } = useSpecialRights();
  const { ready } = useTranslation();
  const imagesLoaded = usePreloadImageManifest("/image-manifest.json");

  if (!ready || !imagesLoaded || isLoading) {
    return <FullPageSpinner />;
  }

  return (
    <AppContainer>
      <Box className="content">
        <IrebookWelcomePopup />
        <Topbar />
        <Toastify />
        <Outlet />
        <Footer />
      </Box>
    </AppContainer>
  );
};

export default AppContent;
